import ZariForm from './form'
import ZariFormGroup from './group'
import ZariInputGroup from './inputGroup'
import ZariLabel from './label'
import ZariFeedback from './feedback'

import ZariInputDate from './inputDate'
import ZariInputEmail from './inputEmail'
import ZariInputText from './inputText'
import ZariInputPassword from './inputPassword'
import ZariInputFile from './inputFile'
import ZariInputNumber from './inputNumber'
import ZariOnlyText from './onlyText'
import ZariSelect from './select'
import ZariTextArea from './textarea'
import ZariCheckbox from './checkbox'
import ZariRadio from './radio'
import ZariWysiwyg from './wysiwyg'

ZariForm.Feedback = ZariFeedback
ZariForm.Group = ZariFormGroup
ZariForm.Label = ZariLabel
ZariForm.InputDate = ZariInputDate
ZariForm.InputEmail = ZariInputEmail
ZariForm.InputText = ZariInputText
ZariForm.InputGroup = ZariInputGroup
ZariForm.InputFile = ZariInputFile
ZariForm.InputNumber = ZariInputNumber
ZariForm.InputPassword = ZariInputPassword
ZariForm.OnlyText = ZariOnlyText
ZariForm.Select = ZariSelect
ZariForm.TextArea = ZariTextArea
ZariForm.Checkbox = ZariCheckbox
ZariForm.Radio = ZariRadio
ZariForm.Wysiwyg = ZariWysiwyg

export default ZariForm
